// @ts-nocheck -- staged migration: add explicit types before removing this directive.
export const hiraganas = [
    {
        symbol: " ",
        romaji: "space",
    },
    {
        symbol: "、",
        romaji: ",",
    },
    {
        symbol: "。",
        romaji: ".",
    },
    {
        symbol: "？",
        romaji: "?",
    },
    {
        symbol: "！",
        romaji: "!",
    },
    {
        symbol: "ー",
        romaji: "-",
    },
    {
        symbol: "・",
        romaji: "dot",
    },
    {

        symbol: "あ",
        romaji: "a",
    },
    {
        symbol: "い",
        romaji: "i",
    },
    {
        symbol: "う",
        romaji: "u",
    },
    {
        symbol: "え",
        romaji: "e",
    },
    {
        symbol: "お",
        romaji: "o",
    },
    {
        symbol: "か",
        romaji: "ka",
    },
    {
        symbol: "き",
        romaji: "ki",
    },
    {
        symbol: "く",
        romaji: "ku",
    },
    {
        symbol: "け",
        romaji: "ke",
    },
    {
        symbol: "こ",
        romaji: "ko",
    },
    {
        symbol: "きゃ",
        romaji: "kya",
    },
    {
        symbol: "きゅ",
        romaji: "kyu",
    },
    {
        symbol: "きょ",
        romaji: "kyo",
    },
    {
        symbol: "さ",
        romaji: "sa",
    },
    {
        symbol: "し",
        romaji: "shi",
    },
    {
        symbol: "す",
        romaji: "su",
    },
    {
        symbol: "せ",
        romaji: "se",
    },
    {
        symbol: "そ",
        romaji: "so",
    },
    {
        symbol: "しゃ",
        romaji: "sha",
    },

    {
        symbol: "しゅ",
        romaji: "shu",
    },
    {
        symbol: "しょ",
        romaji: "sho",
    },
    {
        symbol: "た",
        romaji: "ta",
    },
    {
        symbol: "ち",
        romaji: "chi",
    },
    {
        symbol: "つ",
        romaji: "tsu",
    },
    {
        symbol: "っ",
        romaji: "small-tsu",

    },
    {
        symbol: "て",
        romaji: "te",
    },
    {
        symbol: "と",
        romaji: "to",
    },
    {
        symbol: "ちゃ",
        romaji: "cha",
    },
    {
        symbol: "ちゅ",
        romaji: "chu",
    },
    {
        symbol: "ちょ",
        romaji: "cho",
    },
    {
        symbol: "な",
        romaji: "na",
    },
    {
        symbol: "に",
        romaji: "ni",
    },
    {
        symbol: "ぬ",
        romaji: "nu",
    },
    {
        symbol: "ね",
        romaji: "ne",
    },
    {
        symbol: "の",
        romaji: "no",
    },
    {
        symbol: "にゃ",
        romaji: "nya",
    },
    {
        symbol: "にゅ",
        romaji: "nyu",
    },
    {
        symbol: "にょ",
        romaji: "nyo",
    },
    { symbol: "は", romaji: "ha" },
    { symbol: "ひ", romaji: "hi" },
    { symbol: "ふ", romaji: "fu" },
    { symbol: "へ", romaji: "he" },
    { symbol: "ほ", romaji: "ho" },
    {
        symbol: "ひゃ",
        romaji: "hya",
    },
    {
        symbol: "ひゅ",
        romaji: "hyu",
    },
    {
        symbol: "ひょ",
        romaji: "hyo",
    },
    {
        symbol: "ま",
        romaji: "ma",
    },
    {
        symbol: "み",
        romaji: "mi",
    },
    {
        symbol: "む",
        romaji: "mu",
    },
    {
        symbol: "め",
        romaji: "me",
    },
    {
        symbol: "も",
        romaji: "mo",
    },
    {
        symbol: "みゃ",
        romaji: "mya",
    },
    {
        symbol: "みゅ",
        romaji: "myu",
    },
    {
        symbol: "みょ",
        romaji: "myo",
    },
    {
        symbol: "や",
        romaji: "ya",
    },
    {
        symbol: "ゃ",
        romaji: "small-ya",
    },
    {
        symbol: "ゆ",
        romaji: "yu",
    },
    {
        symbol: "ゅ",
        romaji: "small-yu",
    },
    {
        symbol: "よ",
        romaji: "yo",
    },
    {
        symbol: "ょ",
        romaji: "small-yo",
    },
    {
        symbol: "ら",
        romaji: "ra",
    },
    {
        symbol: "り",
        romaji: "ri",
    },
    {
        symbol: "る",
        romaji: "ru",
    },
    {
        symbol: "れ",
        romaji: "re",
    },
    {
        symbol: "ろ",
        romaji: "ro",
    },
    {
        symbol: "りゃ",
        romaji: "rya",
    },
    {
        symbol: "りゅ",
        romaji: "ryu",
    },
    {
        symbol: "りょ",
        romaji: "ryo",
    },
    {
        symbol: "わ",
        romaji: "wa",
    },
    {
        symbol: "ゐ",
        romaji: "wi",
    },
    {
        symbol: "ゑ",
        romaji: "we",
    },
    {
        symbol: "を",
        romaji: "wo",
    },
    {
        symbol: "が",
        romaji: "ga",
    },
    {
        symbol: "ぎ",
        romaji: "gi",
    },
    {
        symbol: "ぐ",
        romaji: "gu",
    },
    {
        symbol: "げ",
        romaji: "ge",
    },
    {
        symbol: "ご",
        romaji: "go",
    },
    {
        symbol: "ぎゃ",
        romaji: "gya",
    },
    {
        symbol: "ぎゅ",
        romaji: "gyu",
    },
    {
        symbol: "ぎょ",
        romaji: "gyo",
    },
    {
        symbol: "ざ",
        romaji: "za",
    },
    {
        symbol: "じ",
        romaji: "ji",
    },
    {
        symbol: "ず",
        romaji: "zu",
    },
    {
        symbol: "ぜ",
        romaji: "ze",
    },
    {
        symbol: "ぞ",
        romaji: "zo",
    },
    {
        symbol: "じゃ",
        romaji: "ja",
    },
    {
        symbol: "じゅ",
        romaji: "ju",
    },
    {
        symbol: "じょ",
        romaji: "jo",
    },
    {
        symbol: "だ",
        romaji: "da",
    },
    {
        symbol: "ぢ",
        romaji: "ji",
    },
    {
        symbol: "づ",
        romaji: "zu",
    },
    {
        symbol: "で",
        romaji: "de",
    },
    {
        symbol: "ど",
        romaji: "do",
    },
    {
        symbol: "ぢゃ",
        romaji: "ja",
    },
    {
        symbol: "ぢゅ",
        romaji: "ju",
    },
    {
        symbol: "ぢょ",
        romaji: "jo",
    },
    {
        symbol: "ば",
        romaji: "ba",
    },
    {
        symbol: "び",
        romaji: "bi",
    },
    {
        symbol: "ぶ",
        romaji: "bu",
    },
    {
        symbol: "べ",
        romaji: "be",
    },
    {
        symbol: "ぼ",
        romaji: "bo",
    },
    {
        symbol: "びゃ",
        romaji: "bya",
    },
    {
        symbol: "びゅ",
        romaji: "byu",
    },
    {
        symbol: "びょ",
        romaji: "byo",
    },
    {
        symbol: "ぱ",
        romaji: "pa",
    },
    {
        symbol: "ぴ",
        romaji: "pi",
    },
    {
        symbol: "ぷ",
        romaji: "pu",
    },
    {
        symbol: "ぺ",
        romaji: "pe",
    },
    {
        symbol: "ぽ",
        romaji: "po",
    },
    {
        symbol: "ぴゃ",
        romaji: "pya",
    },
    {
        symbol: "ぴゅ",
        romaji: "pyu",
    },
    {
        symbol: "ぴょ",
        romaji: "pyo",
    },
    {
        symbol: "ん",
        romaji: "n",
    }
];
